'use strict';
Object.defineProperty(exports, '__esModule', {
    value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require('react'));

var _propTypes = _interopRequireDefault(require('prop-types'));

var _shared = _interopRequireDefault(require('./shared'));

var _styledComponents = _interopRequireDefault(require('styled-components'));

var _edenStyleConstants = require('../../../../eden-style-constants');

var _hex2rgba = _interopRequireDefault(require('hex2rgba'));

function _interopRequireDefault(obj) {
    return obj && obj.__esModule ? obj : { default: obj };
}

function _extends() {
    _extends =
        Object.assign ||
        function(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i];
                for (var key in source) {
                    if (Object.prototype.hasOwnProperty.call(source, key)) {
                        target[key] = source[key];
                    }
                }
            }
            return target;
        };
    return _extends.apply(this, arguments);
}

const Component = _styledComponents.default.button.withConfig({
    componentId: 'sc-7932sm-0'
})(
    ['', ';background:none;color:', ';&:hover{background:', ';color:', ';}&:active{background:', ';}'],
    _shared.default,
    ({ inverted }) => (inverted ? _edenStyleConstants.white : _edenStyleConstants.blue30),
    ({ inverted }) =>
        inverted ? (0, _hex2rgba.default)(_edenStyleConstants.grey40, 0.6) : (0, _hex2rgba.default)(_edenStyleConstants.grey3, 0.6),
    ({ inverted }) => (inverted ? _edenStyleConstants.white : _edenStyleConstants.blue30),
    ({ inverted }) => (inverted ? _edenStyleConstants.grey40 : _edenStyleConstants.grey3)
);
/**
 * Ghost buttons are subservient and supportive to a Primary and Secondary button. These should be used to indicate something that is optional or unessential for a user to complete a specific task.
 */

const Ghost = /*#__PURE__*/ _react.default.forwardRef((props, ref) =>
    /*#__PURE__*/ _react.default.createElement(
        Component,
        _extends({}, props, {
            ref: ref,
            as: props.disabled ? 'button' : props.href ? 'a' : 'button'
        }),
        props.children
    )
);

Ghost.defaultProps = {
    type: 'button'
};
Ghost.displayName = 'Ghost';
Ghost.propTypes = {
    /** The button contents */
    children: _propTypes.default.node.isRequired,

    /** Whether to apply styles that help the button stand out on a dark background */
    inverted: _propTypes.default.bool,

    /** Whether to apply smaller styles */
    small: _propTypes.default.bool,

    /** The [type of the button](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/button#Attributes), if an href is present it will be the [type of the link](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a#Attributes) */
    type: _propTypes.default.string,

    /** If the button should expand to the full width of its parent */
    fullWidth: _propTypes.default.bool,

    /** If the button should be disabled */
    disabled: _propTypes.default.bool,

    /** The link that the button should navigate to on click */
    href: _propTypes.default.string
};
var _default = Ghost;
exports.default = _default;
